import ImageLoader from '../../ImageLoader';
import star from '../../../common/images/revamp/icon/star.svg';
import motorbike from '../../../common/images/revamp/icon/motorbike.svg';
import { isEmptyData, checkHoldTime, checkTime } from '../../../utils/helper';
import useNavigation from '../../../hook/useNavigation';
import { ClockIcon } from '@heroicons/react/24/solid';

const Card = (props) => {
	const { item } = props;

	const navigate = useNavigation();
	const distance = parseFloat(item?.distance || 0)?.toFixed('1');

	const formatDiscount = (value) => {
		const amount = Number(value);
		if (amount >= 1000000) {
			return `${amount / 1000000}M`;
		}
		if (amount >= 1000) {
			return `${amount / 1000}K`;
		}
		return `${amount}`;
	};

	const bestVoucher = item?.voucher_global
		?.filter((v) => v.purpose === 'PRODUCT')
		?.reduce((best, current) => {
			if (!best) return current;
			const bestDiscount = best.type === 'percentage' ? Number(best.max_discount) : Number(best.value);
			const currentDiscount = current.type === 'percentage' ? Number(current.max_discount) : Number(current.value);
			return currentDiscount > bestDiscount ? current : best;
		}, null);

	const maxDiscount = bestVoucher ? formatDiscount(bestVoucher.type === 'percentage' ? bestVoucher.max_discount : bestVoucher.value) : null;

	const handleClick = () => {
		if (item?.storeOpen === '1') {
			navigate.push({
				pathname: `/outlet/${item?.storeSlug}/delivery`,
				state: {
					storeID: item?.storeID,
					storeSlug: item?.storeSlug,
					storeName: item?.storeName,
					storeImage: item?.storeImage,
					rating: item?.rating,
					bannerImage: item?.storeBannerImage,
				},
			});
		}
	};

	const isBusy = item?.endHold && checkHoldTime(item?.endHold);
	const outletStatus = isBusy ? `Resto sedang sibuk` : `Tutup${item?.outletOpenTime ? ` - Buka pukul ${item?.outletOpenTime} ${checkTime(item?.outletOpenTime)} hari ini` : ''}`;

	return (
		<div className='w-32 h-full bg-white rounded-md z-0' onClick={handleClick}>
			<ImageLoader src={item?.storeImage} className='aspect-square h-32 w-32 rounded-t-md object-cover object-center' />
			<div className='flex flex-col gap-1 p-2'>
				<div className='flex flex-wrap gap-x-3 gap-y-1 items-center !mt-0'>
					<div className={`${isEmptyData(item?.rating) ? 'hidden' : 'flex'}  items-center gap-1`}>
						<img src={star} alt='star' />
						<span className='font-medium text-xxs text-[var(--dark-gray)]'>
							{item?.rating || 0} ({item?.totalRating || 0})
						</span>
					</div>
					<div className='flex items-center gap-1'>
						<img src={motorbike} alt='motorbike' />
						<span className='text-xxs'>{distance} km</span>
					</div>
				</div>
				<div className={`${item?.storeOpen === '0' ? 'flex' : 'hidden'} items-center`}>
					<ClockIcon class='h-2 w-2 text-red-500 mr-1'/>
					<div className='text-xxs text-gray-900'>{outletStatus}</div>
				</div>
				<p className={`line-clamp-2 font-semibold text-xxs cursor-pointer text-gray-700`}>{item?.storeName}</p>
				<span className={`font-semibold text-xxs text-blue-500 ${isEmptyData(maxDiscount) && 'hidden'}`}>Diskon Hingga {maxDiscount}</span>
			</div>
		</div>
	);
};

export default Card;
